var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.60061 8.39312e-07L12 2.49941L4.8003 9.99921L12 17.499L9.6006 19.9984L-8.74297e-07 10.0008L9.60061 8.39312e-07Z","fill":"#072A3F"}));
}

ArrowLeft.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
